module.exports = __webpack_public_path__ + "static/media/dummy_graph_1.ed054317.png";